import { ControlIcons } from 'owa-control-icons';

export function getIconFromProviderName(provider: string): string | null {
    switch (provider) {
        case 'SkypeForBusiness':
            return ControlIcons.SkypeForBusinessLogo16;
        case 'SkypeForConsumer':
            return ControlIcons.SkypeLogo16;
        case 'TeamsForBusiness':
            return ControlIcons.TeamsLogo;
        default:
            return null;
    }
}
